import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type Lesson = Database['public']['Tables']['lessons']['Row'];
type Course = Database['public']['Tables']['courses']['Row'];
type LessonProgress = Database['public']['Tables']['lesson_progress']['Row'];

export type LessonWithProgress = Lesson & {
  progress?: LessonProgress | null;
  course: Pick<Course, 'id' | 'title' | 'slug'>;
};

export type CourseNavigation = {
  lessons: Array<{
    id: string;
    title: string;
    position: number;
    section_id: string | null;
  }>;
  totalLessons: number;
};

type LessonInsert = Database['public']['Tables']['lessons']['Insert'];
type LessonUpdate = Database['public']['Tables']['lessons']['Update'];

export const lessonService = {
  /**
   * Get a single lesson with course info and user's progress
   */
  getLesson: (lessonId: string): Promise<LessonWithProgress> => 
    apiClient.get<LessonWithProgress>(`/lessons/${lessonId}`) as unknown as Promise<LessonWithProgress>,
  
  /**
   * Get course navigation (lessons list) for a course
   */
  getCourseNavigation: (courseId: string): Promise<CourseNavigation> => 
    apiClient.get<CourseNavigation>(`/lessons/course/${courseId}/navigation`) as unknown as Promise<CourseNavigation>,
  
  /**
   * Create a new lesson (admin only)
   */
  createLesson: (lessonData: LessonInsert): Promise<Lesson> => 
    apiClient.post<Lesson>('/lessons', lessonData) as unknown as Promise<Lesson>,
  
  /**
   * Update a lesson (admin only)
   */
  updateLesson: (lessonId: string, updates: LessonUpdate): Promise<Lesson> => 
    apiClient.patch<Lesson>(`/lessons/${lessonId}`, updates) as unknown as Promise<Lesson>,
  
  /**
   * Delete a lesson (admin only)
   */
  deleteLesson: (lessonId: string): Promise<void> => 
    apiClient.delete(`/lessons/${lessonId}`),
};
